import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "app-toast-host",
  "aria-live": "polite",
  "aria-atomic": "true"
}
const _hoisted_2 = { class: "app-toast-icon" }
const _hoisted_3 = { class: "app-toast-content" }
const _hoisted_4 = {
  key: 0,
  class: "app-toast-title"
}
const _hoisted_5 = { class: "app-toast-message" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
      return (_openBlock(), _createElementBlock("div", {
        key: toast.id,
        class: _normalizeClass(["app-toast", `app-toast--${toast.type}`])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa", _ctx.iconClass(toast.type)])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (toast.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(toast.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, _toDisplayString(toast.message), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "app-toast-close",
          "aria-label": "Fermer",
          onClick: ($event: any) => (_ctx.dismiss(toast.id))
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fa fa-times" }, null, -1)
        ]))], 8, _hoisted_6)
      ], 2))
    }), 128))
  ]))
}